/**
 * Shared break types for API contracts between frontend and backend
 */
import { z } from "zod";
import { uuidSchema, } from "./validation-common.js";
export const CreateBreakInputSchema = z.object({
    shiftLengthThresholdMinutes: z.number().int().min(0),
    startOffsetMinutes: z.number().int().min(0).nullable().optional(),
    breakLengthMinutes: z.number().int().positive(),
    isPaid: z.boolean(),
    description: z.string().max(50).optional(),
    emoji: z.string().max(10).optional(),
    jobRoleFamilyId: uuidSchema.optional(),
    shiftId: uuidSchema.optional(),
});
export const UpdateBreakInputSchema = z.object({
    shiftLengthThresholdMinutes: z.number().int().min(0).optional(),
    startOffsetMinutes: z.number().int().min(0).nullable().optional(),
    breakLengthMinutes: z.number().int().positive().optional(),
    isPaid: z.boolean().optional(),
    description: z.string().max(50).optional(),
    emoji: z.string().max(10).optional(),
});
export const BreakIdParamSchema = z.object({
    id: uuidSchema,
});
// Response schema for API output validation
export const BreakResponseSchema = z.object({
    id: z.uuid(),
    shiftLengthThresholdMinutes: z.number(),
    breakLengthMinutes: z.number(),
    startOffsetMinutes: z.number().nullable(),
    isPaid: z.boolean(),
    description: z.string().optional(),
    emoji: z.string().optional(),
    jobRoleFamilyId: z.uuid().optional(),
    shiftId: z.uuid().optional(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
});
